
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/travel-insurance/[country]",
      function () {
        return require("private-next-pages/travel-insurance/[country].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/travel-insurance/[country]"])
      });
    }
  